import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { removeUserSession, getToken, getUser } from "../../../Utils/Common";
// import Logo from "../../../../logo.png";
// import "./homelayout.css";

const HomeLayout = ({ userData }) => {
  const token = getToken();
  const user = getUser();
  let navigate = useNavigate();

  const handleLogout = () => {
    removeUserSession();
    navigate("/login");
  };

  const handleRedirect = () => {
    window.location.reload(navigate("/contact"));
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg fixed-top navbar-dark pe-9"
        style={{ zIndex: "102" }}
      >
        <div className="container-fluid">
          <Link className="navbar-brand" to="#">
            <img src="./logo.png" alt="" />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarText"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ marginTop: "-55px" }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
            style={{ marginTop: "-106px", zIndex: "102" }}
          >
            {!token ? (
              <ul className="navbar-nav ms-auto mb-6 mb-lg-0">
                <li className="nav-item m-7 fs-1">
                  <Link
                    onClick={handleRedirect}
                    className="text-white"
                    to={`#`}
                  >
                    Help
                  </Link>
                </li>
                <li className="nav-item m-7 fs-1">
                  <Link className="text-white" to={`/login`}>
                    Log in
                  </Link>
                </li>
              </ul>
            ) : (
              <ul className="navbar-nav ms-auto mb-6 mb-lg-0">
                <li className="nav-item m-7 fs-1">
                  <Link
                    onClick={handleRedirect}
                    className="text-white"
                    to={`#`}
                  >
                    Help
                  </Link>
                </li>
                <li className="nav-item m-7 fs-1 text-white ">
                  <Link
                    onClick={handleLogout}
                    to={`/login`}
                    className="text-white"
                  >
                    Log out
                  </Link>
                </li>
              </ul>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default HomeLayout;
